import React from 'react';
import { BookingType, ServiceType } from 'utilities/enum-utils';
import { FaUserFriends, FaUsers, FaUserSlash } from 'react-icons/fa';
import { AiOutlineBook, AiFillHome } from 'react-icons/ai';
import { Center, ThemeIcon, ThemeIconProps } from '@good/ui/core';

type IconType = ServiceType | 'ACTIVITY_RECORD';

interface IBookingTypeIconProps extends ThemeIconProps {
  size?: ThemeIconProps['size'] | 'small' | 'default' | 'large';
  className?: string;
  type: IconType;
}

const BookingTypeIcon = ({ size: sizeProp = 'sm', className, type, style, ...props }: IBookingTypeIconProps) => {
  const getIcon = (type: IconType, className?: string, style?: React.CSSProperties) => {
    switch (type) {
      case ServiceType.GROUP:
        return <FaUsers className={className} />;
      case ServiceType.INDIVIDUAL:
        return <FaUserFriends className={className} />;
      case ServiceType.COORDINATION:
        return <AiOutlineBook className={className} />;
      case ServiceType.INDEPENDENT_LIVING:
        return <AiFillHome className={className} />;
      case BookingType.ACTIVITY_RECORD:
        return <FaUserSlash className={className} />;
      default:
        return <FaUserSlash className={className} />;
    }
  };

  const iconColor = {
    GROUP: 'lilac.3',
    INDIVIDUAL: 'green.3',
    COORDINATION: 'red',
    INDEPENDENT_LIVING: 'violet',
    ACTIVITY_RECORD: 'yellow',
  }[type];

  let size = sizeProp;
  if (sizeProp === 'default') {
    size = 'sm';
  } else if (sizeProp === 'large') {
    size = 'md';
  } else if (sizeProp === 'small') {
    size = 'xs';
  }

  return (
    <ThemeIcon color={iconColor} variant='default' className={className} size={size} c='gray.6' {...props}>
      <Center w='70%' h='70%'>
        {getIcon(type, '', style as React.CSSProperties)}
      </Center>
    </ThemeIcon>
  );
};

export default BookingTypeIcon;
